export default "__VITE_ASSET__ce725ad8__"